import { graphql } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import TopFooter from "~/components/Footer/TopFooter";

import withTranslationProps from "~/hoc/withTranslationProps";
import { translateFooter } from "~/translators/functions";

const TopFooterBlock = ({ pageTitle, translationProps, data }) => {
    const { wp } = data;

    const topFooter = translateFooter(
        wp?.optionsPageTranslations,
        translationProps,
    );

    const socialLinks = topFooter?.socialLinks?.socialLink ?? null;
    const topFooterSection = topFooter?.topFooterSection ?? null;
    const title = topFooterSection?.title ?? null;
    const expertColumn = topFooterSection?.expertColumn ?? null;
    const whereToBuyColumn = topFooterSection?.whereToBuyColumn ?? null;
    const stayConnectedColumn = topFooterSection?.stayConnectedColumn ?? null;

    return (
        <TopFooter
            {...{
                socialLinks,
                title,
                expertColumn,
                whereToBuyColumn,
                stayConnectedColumn,
                pageTitle,
            }}
        />
    );
};

TopFooterBlock.propTypes = {
    pageTitle: PropTypes.string.isRequired,
};

export default withTranslationProps(TopFooterBlock);

export const query = graphql`
    query TopFooterBlockQuery {
        wp {
            optionsPageTranslations {
                languageCode
                socialLinks {
                    socialLink {
                        icon
                        linkUrl
                        screenReaderText
                    }
                }
                topFooterSection {
                    title
                    expertColumn {
                        title
                        copy
                        buttonLabel
                        buttonUrl
                        callText
                    }
                    whereToBuyColumn {
                        title
                        copy
                        searchOptions {
                            text
                            value
                        }
                        searchPlaceholder
                        shopText
                    }
                    stayConnectedColumn {
                        title
                        copy
                        pageTitleInputId
                        pageUrlInputId
                        formId
                    }
                }
            }
        }
    }
`;
